import { ComponentType } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { getSideNavState } from 'client/ducks/app/selectors';
import { ApplicationState } from 'client/ducks/app/reducer';
import { toggleSideNav } from 'client/ducks/app/actions';
import { ComponentProps, DispatchProps, StateProps } from '@components/side-nav-container/side-nav-container';
import SideNavContainer from './side-nav-container';

const mapStateToProps = (state: ApplicationState) => {
    return {
        sideNavIsOpened: getSideNavState(state)
    };
};

const mapDispatchToProps = { toggleSideNav };

export default compose<ComponentType<ComponentProps>>(
    connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps),
    withRouter
)(SideNavContainer);
